import React, { useEffect, useState } from 'react';
import { clampNumber } from './startupCalculatorLogic';

const StartupCalculatorNumberField = ({
  label,
  subLabel,
  note,
  unit,
  value,
  onChange,
  min,
  max,
  step = 1,
}) => {
  const [draft, setDraft] = useState(String(value));
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDraft(String(value));
    }
  }, [value, isFocused]);

  const handleChange = (event) => {
    const raw = event.target.value;

    if (raw === '') {
      setDraft('');
      return;
    }

    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) {
      return;
    }

    setDraft(raw);
    onChange(clampNumber(parsed, min, max));
  };

  const handleFocus = (event) => {
    setIsFocused(true);
    setDraft(String(value));
    event.target.select();
  };

  const handleBlur = () => {
    setIsFocused(false);

    if (draft === '') {
      onChange(min);
      setDraft(String(min));
      return;
    }

    const parsed = clampNumber(draft, min, max);
    onChange(parsed);
    setDraft(String(parsed));
  };

  return (
    <div className="sc-field">
      <div className="sc-field-label">
        <span>{label}</span>
        {subLabel ? <span className="sc-field-sub">{subLabel}</span> : null}
      </div>
      <div className="sc-input-wrap">
        <input
          type="number"
          className="sc-input"
          min={min}
          max={max}
          step={step}
          value={isFocused ? draft : value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {unit ? <span className="sc-input-unit">{unit}</span> : null}
      </div>
      {note ? <p className="sc-field-note">{note}</p> : null}
    </div>
  );
};

export default StartupCalculatorNumberField;
